/**
 * Auth Validation Schemas
 * Shared Zod schemas for authentication and guest forms
 */

import { z } from 'zod';

/**
 * Create email validation schema with localized messages
 */
export const createEmailSchema = (messages?: {
  required?: string;
  invalid?: string;
}) => z.string()
  .min(1, messages?.required || 'Email is required')
  .regex(
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    messages?.invalid || 'Invalid email address'
  )
  .max(255);

/**
 * Create password validation schema with localized messages
 */
export const createPasswordSchema = (messages?: {
  minLength?: string;
}) => z.string()
  .min(6, messages?.minLength || 'Password must be at least 6 characters')
  .max(100);

/**
 * Create name validation schema with localized messages
 */
export const createNameSchema = (messages?: {
  minLength?: string;
}) => z.string()
  .trim()
  .min(2, messages?.minLength || 'Name must be at least 2 characters')
  .max(100);

/**
 * Default schemas for non-localized contexts
 */
export const emailSchema = createEmailSchema();
export const passwordSchema = createPasswordSchema();
export const nameSchema = createNameSchema();
